import { AppState } from '../../../../core/Store';
import { State } from './reducer';

type Selector<T = any> = (redState: State, appState: AppState) => T;
function prepareSelector<T>(selector: Selector<T>) {
	return (state: AppState) => {
		return selector(state.data.dictionaries.consentsDict, state);
	};
}

export const getConsentsStage1 = prepareSelector((redState, appState) => {
	return redState.consentsStage1;
});

export const getConsentsStage2 = prepareSelector((redState, appState) => {
	return redState.consentsStage2;
});

export const getLoaded = prepareSelector((redState, appState) => {
	return redState.loaded;
});
